import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-form login-form-limited scroll-wrapper" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = {
  key: 0,
  class: "wrapper-member"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close,
    classes: $setup.modalClasses,
    "transition-name": $props.transitionName
  }, {
    content: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-title" }, "Log in to LotTrackr", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input--focus input-large", { 'input--error': $setup.v$.email.$error }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.email) = $event)),
                placeholder: "Type your email"
              }, null, 2), [
                [_vModelText, $setup.form.email]
              ])
            ]),
            ($setup.v$.email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "label" }, "Password", -1)),
              _createVNode($setup["InputPassword"], {
                modelValue: $setup.form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.password) = $event)),
                "input-classes": ['input-large', 'input--focus', { 'input--error': $setup.v$.password.$error }],
                placeholder: "Type your password"
              }, null, 8, ["modelValue", "input-classes"])
            ]),
            ($setup.v$.password.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.v$.password.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "button button--login primary w-100",
              onClick: _withModifiers($setup.login, ["prevent"]),
              disabled: $setup.isDisabledLogin
            }, "Log in", 8, _hoisted_8),
            ($setup.props.loginError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.props.loginError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", { class: "form-group mb-12" }, [
            _createElementVNode("span", {
              class: "forgot-password",
              onClick: $setup.onForgotPassword
            }, "Forgot password?")
          ]),
          ($props.joining)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "member" }, "Don't have an account yet? ", -1)),
                _createElementVNode("span", {
                  class: "join",
                  onClick: $setup.join
                }, "Create free account")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open", "classes", "transition-name"]))
}